/**
 * Site configuration — non-brand technical settings.
 * Brand identity (name, domain, support email, etc.) lives in `lib/branding.config.ts`.
 */

import { branding } from "@/lib/branding.config";

export const siteConfig = {
  name: branding.name,
  description: "Cloud GPU rental on demand. Powerful machines for AI, gaming, and creative workloads.",
  url: branding.appUrl,
  links: {
    support: "/support",
    coverage: "/coverage",
    faq: "/faq",
  },
  payment: {
    minAmount: parseFloat(process.env.PAYMENT_MIN_AMOUNT || "5"),
    maxAmount: parseFloat(process.env.PAYMENT_MAX_AMOUNT || "500"),
    currency: "EUR",
    /** Set to false to temporarily disable all payment gateway access (top-ups and direct purchases) */
    enabled: process.env.NEXT_PUBLIC_PAYMENTS_ENABLED !== "false",
  },
} as const;
